import { Subheading, MenuItem } from "../../components";
import { data, images } from "../../constants";

const SpecialMenu = () => (
  <div className="menu flex__center section__padding" id="menu">
    <div className="menu__title">
      <Subheading title="Menu that fits your palatte" />
      <h1 className="headtext__cormorant">Today&apos;s Special</h1>
    </div>

    <div className="menu__card">
      <div className="menu__card-wine  flex__center">
        <p className="menu__card-heading">Wine & Beer</p>
        <div className="menu__card-items">
          {data.wines.map((wine, index) => (
            <MenuItem
              key={wine.title + index}
              title={wine.title}
              price={wine.price}
              tags={wine.tags}
            />
          ))}
        </div>
      </div>

      <div className="menu__card-img">
        <img src={images.menu} alt="menu " />
      </div>

      <div className="menu__card-cocktails  flex__center">
        <p className="menu__card-heading">Cocktails</p>
        <div className="menu__card-items">
          {data.cocktails.map((cocktail, index) => (
            <MenuItem
              key={cocktail.title + index}
              title={cocktail.title}
              price={cocktail.price}
              tags={cocktail.tags}
            />
          ))}
        </div>
      </div>
    </div>

    <div style={{ marginTop: 15 }}>
      <button type="button" className="custom__button">
        View More
      </button>
    </div>
  </div>
);

export default SpecialMenu;
